import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["messages", "message"]

  connect() {
    this.scrollToBottom()
  }

  messageTargetConnected() {
    this.scrollToBottom()
  }

  scrollToBottom() {
    const messages = this.element.querySelector("#chat-messages")
    if (messages) {
      messages.scrollTop = messages.scrollHeight
    }
  }
}
